import {
	Component,
	Input,
	OnDestroy,
	OnInit,
	Signal,
	ViewEncapsulation,
	signal,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

interface Scope {
	loading: Signal<boolean>;
}

@Component({
	selector: 'ms-color-picker',
	templateUrl: './ms-color-picker.component.html',
	styleUrls: ['./ms-color-picker.component.scss'],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class MsColorPickerComponent implements OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() title: string;
	@Input() key: string;

	scope: Scope = {
		loading: signal(true),
	};

	/**
	 * Constructor
	 */
	constructor(private _formBuilder: UntypedFormBuilder) {
		this.scope.loading = signal(false);
		if (!this.formGroup) {
			this.formGroup = this._formBuilder.group({
				name: [null, [Validators.required]],
			});
		}
	}

	// -----------------------------------------------------------------------------------------------------
	// @ Lifecycle hooks
	// -----------------------------------------------------------------------------------------------------

	/**
	 * On init
	 */
	ngOnInit(): void {}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {}

	// -----------------------------------------------------------------------------------------------------
	// @ Public methods
	// -----------------------------------------------------------------------------------------------------

	// -----------------------------------------------------------------------------------------------------
	// @ Private methods
	// -----------------------------------------------------------------------------------------------------
}
